import React from "react";
import { render } from "react-dom";

import { AllowedMenuItemCodes } from "@multiweb/types/contracts";
import { IMainMenu, IWindowable } from "@multiweb/types/multiweb";
import { menuModule } from "./menu";
import { createRootComponent } from "./setup";

/**
 * Slouží k propojení stávající aplikace a menu.
 */
export class MenuAppConnector implements IMainMenu {
    /**
     * @param elementId Id elementu, do kterého bude menu zapojeno.
     * @param devMode Indikátor vývojového módu. Aktivuje redux-dev-tools.
     * @param allowedMenuItemCodes Aliasy povolených kořenových formulářových uzlů hlavního navigačního menu. Převod na null kvůli ukládání do stavu.
     * @param showMenuExpanded Pokud je true, je menu v počátečním stavu rozbalené. Pokud je false je sbalené.
     * @param showMenuPanelCaptions Pokud je true, u položek menu panelu se zobrazí popisek. Pokud je false, popisky se nezobrazí.
     */
    constructor(elementId: string, devMode: boolean, allowedMenuItemCodes: AllowedMenuItemCodes = null, showMenuExpanded: boolean, showMenuPanelCaptions: boolean) {
        const rootElement = document.getElementById(elementId);
        const RootComponent = createRootComponent(devMode);
        render(
            <RootComponent>
                {menuModule.Container && (
                    <menuModule.Container {...{ allowedMenuItemCodes, showMenuExpanded, showMenuPanelCaptions }} />
                )}
            </RootComponent>,
            rootElement,
        );
    }

    public registerOpenedWindow(_window: IWindowable): void {
        // Není třeba implementovat. Menu si zaregistruje vlastní posluchač pro otevření formuláře.
    }
}
